import heroImage from '../../../assets/PayDay/heroImage.webp';
import weekendHeroBanner from '../../../assets/weeekend/weekendHeroBanner.webp';
import gateWayHeroBanner from '../../../assets/GateWay/longWeekendHeroBanner.webp';
import bgImage from '../../../assets/PayDay/bgImage.webp';
import metric from '../../../assets/PayDay/Metrics.webp';
import close from '../../../assets/PayDay/drop-down.svg';

//categories
import food from '../../../assets/PayDay/dailySaving/food.webp';
import food2 from '../../../assets/PayDay/dailySaving/food2.svg';
import travel from '../../../assets/PayDay/dailySaving/travel.webp';
import shopping from '../../../assets/PayDay/dailySaving/shopping.webp';
import bill from '../../../assets/PayDay/dailySaving/bill.webp';
import entertainment from '../../../assets/PayDay/dailySaving/entertainment.webp';
import electronics from '../../../assets/PayDay/dailySaving/electronics.webp';

// rewards
import reliance from '../../../assets/PayDay/reward/reliance.webp';
import cobb from '../../../assets/PayDay/reward/cobb.webp';
import barista from '../../../assets/PayDay/reward/barista.webp';
import wow from '../../../assets/PayDay/reward/wow.webp';
import mcd from '../../../assets/PayDay/reward/mcd.webp';
import pizzahut from '../../../assets/PayDay/reward/pizzahut.webp';
import bikernerwala from '../../../assets/PayDay/reward/bikernerwala.webp';
import archies from '../../../assets/PayDay/reward/archies.webp';
import manCompany from '../../../assets/PayDay/reward/manCompany.webp';

// brandsSplotlight
import Relience from '../../../assets/PayDay/brand/Relience.webp';
import Swiggy from '../../../assets/PayDay/brand/Swiggy.webp';
import Jiomart from '../../../assets/PayDay/brand/Jiomart.webp';
import Nobero from '../../../assets/PayDay/brand/Nobero.webp';
import Redbus from '../../../assets/PayDay/brand/Redbus.webp';
import MyJio from '../../../assets/PayDay/brand/MyJio.webp';

// other brands
import confirmTkt from '../../../assets/PayDay/otherBrands/confirmTkt.svg';
import mmt from '../../../assets/PayDay/otherBrands/bookmyshow.svg';
import neeman from '../../../assets/PayDay/otherBrands/neemans.svg';
import zeraki from '../../../assets/PayDay/otherBrands/zerakijewels.svg';
import netmed from '../../../assets/PayDay/otherBrands/netmeds.svg';
import justherbs from '../../../assets/PayDay/otherBrands/justherbs.svg';
import es from '../../../assets/PayDay/otherBrands/eatsure.svg';

// secure
import verified from '../../../assets/PayDay/verified.svg';
import secure from '../../../assets/PayDay/secure.svg';
import reserve from '../../../assets/PayDay/reserve.svg';

// app
import earn from '../../../assets/PayDay/app/earn.webp';
import reward from '../../../assets/PayDay/app/reward.webp';
import ixigo from '../../../assets/PayDay/app/ixigo.webp';

// online
import onlinestep1 from '../../../assets/PayDay/Online/onlinestep1.svg';
import onlinestep2 from '../../../assets/PayDay/Online/onlinestep2.svg';
import onlinestep3 from '../../../assets/PayDay/Online/onlinestep3.svg';
import ticket from '../../../assets/PayDay/Online/ticket.svg';

// offline
import offlinestep1 from '../../../assets/PayDay/Offline/offlinestep1.svg';
import offlinestep2 from '../../../assets/PayDay/Offline/offlinestep2.svg';
import weekendofflinestep2 from '../../../assets/PayDay/Offline/weekendofflinestep2.svg';
import offlinestep3 from '../../../assets/PayDay/Offline/offlinestep3.svg';

// user
import usercount from '../../../assets/PayDay/user/usercount.svg';
import rewardSaved from '../../../assets/PayDay/user/rewardSaved.svg';
import rated from '../../../assets/PayDay/user/rated.svg';

//
import bus from '../../../assets/GateWay/category/bus.webp';
import train from '../../../assets/GateWay/category/train.webp';
import flight from '../../../assets/GateWay/category/flight.webp';

/** Season of savings */
// Hero Banner
import seasonOfSavingsHeroBanner from '../../../assets/SeasonOfSavings/seasonOfSavingsHeroBanner.webp';

// categories
import ss_food from '../../../assets/SeasonOfSavings/categories/food.webp';
import ss_travel from '../../../assets/SeasonOfSavings/categories/travel.webp';
import ss_shopping from '../../../assets/SeasonOfSavings/categories/shopping.webp';
import ss_electronics from '../../../assets/SeasonOfSavings/categories/electronics.webp';
import ss_entertainment from '../../../assets/SeasonOfSavings/categories/entertainment.webp';

import ss_bgImage from '../../../assets/SeasonOfSavings/bgImage.webp';

// spotlight brands
import ss_TheManCompany from '../../../assets/SeasonOfSavings/spotlightBrands/TheManCompany.webp';
import ss_Nobero from '../../../assets/SeasonOfSavings/spotlightBrands/Nobero.webp';
import ss_Neemans from '../../../assets/SeasonOfSavings/spotlightBrands/Neemans.webp';
import ss_Boat from '../../../assets/SeasonOfSavings/spotlightBrands/Boat.webp';
import ss_Eatsure from '../../../assets/SeasonOfSavings/spotlightBrands/Eatsure.webp';
import ss_IxigoHotels from '../../../assets/SeasonOfSavings/spotlightBrands/IxigoHotels.webp';
import ss_Redbus from '../../../assets/SeasonOfSavings/spotlightBrands/Redbus.webp';
import ss_EasemyTrip from '../../../assets/SeasonOfSavings/spotlightBrands/EaseMyTrip.webp';

// other brands
import ssob_ConfirmTkt from '../../../assets/SeasonOfSavings/otherBrands/ConfirmTkt.svg';
import ssob_BookMyShow from '../../../assets/SeasonOfSavings/otherBrands/BookMyShow.svg';
import ssob_Neemans from '../../../assets/SeasonOfSavings/otherBrands/Neemans.svg';
import ssob_Zeeraki from '../../../assets/SeasonOfSavings/otherBrands/Zeeraki.svg';
import ssob_Netmeds from '../../../assets/SeasonOfSavings/otherBrands/Netmeds.svg';

// App Excludsive
import ssae_TwidStars from '../../../assets/SeasonOfSavings/appExclusive/TwidStars.webp';
import ssae_TwidScanAndPay from '../../../assets/SeasonOfSavings/appExclusive/TwidScanAndPay.webp';
import ssae_Ixigo from '../../../assets/SeasonOfSavings/appExclusive/Ixigo.webp';

// Republic Day Deals
import republicDayHeroBanner from '../../../assets/RepublicDayDeals/republicDayHeroBanner.webp';
import rdd_electronics from '../../../assets/RepublicDayDeals/categories/electronics.webp';
import rdd_bgImage from '../../../assets/RepublicDayDeals/bgImage.webp';

// RDD - spotlight brands
import rdd_Swiggy from '../../../assets/RepublicDayDeals/spotlightBrands/Swiggy.webp';
import rdd_JioMart from '../../../assets/RepublicDayDeals/spotlightBrands/JioMart.webp';
import rdd_Instamart from '../../../assets/RepublicDayDeals/spotlightBrands/Instamart.webp';
import rdd_AbhiBus from '../../../assets/RepublicDayDeals/spotlightBrands/AbhiBus.webp';
import rdd_Eatsure from '../../../assets/RepublicDayDeals/spotlightBrands/Eatsure.webp';
import rdd_Redbus from '../../../assets/RepublicDayDeals/spotlightBrands/Redbus.webp';
import rdd_Nobero from '../../../assets/RepublicDayDeals/spotlightBrands/Nobero.webp';
import rdd_EasemyTrip from '../../../assets/RepublicDayDeals/spotlightBrands/EaseMyTrip.webp';
import rdd_TheManCompany from '../../../assets/RepublicDayDeals/spotlightBrands/TheManCompany.webp';

// RDD - other brands
import rdd_ob_ConfirmTkt from '../../../assets/RepublicDayDeals/otherBrands/ConfirmTkt.svg';
import rdd_ob_BookMyShow from '../../../assets/RepublicDayDeals/otherBrands/BookMyShow.svg';
import rdd_ob_Zeeraki from '../../../assets/RepublicDayDeals/otherBrands/ZeerakiJewels.svg';
import rdd_ob_Netmeds from '../../../assets/RepublicDayDeals/otherBrands/Netmeds.svg';
import rdd_ob_JustHerbs from '../../../assets/RepublicDayDeals/otherBrands/JustHerbs.svg';

export default {
  weekendHeroBanner,
  heroImage,
  gateWayHeroBanner,
  seasonOfSavingsHeroBanner,
  republicDayHeroBanner,
  bgImage,
  ss_bgImage,
  rdd_bgImage,
  metric,
  close,
  categories: {
    food2,
    food,
    travel,
    shopping,
    bill,
    entertainment,
    electronics,
  },
  rewards: {
    reliance,
    cobb,
    barista,
    wow,
    mcd,
    pizzahut,
    bikernerwala,
    archies,
    manCompany,
  },
  brands: {
    Relience,
    Swiggy,
    Jiomart,
    Nobero,
    Redbus,
    MyJio,
  },
  otherBrands: {
    confirmTkt,
    mmt,
    neeman,
    zeraki,
    netmed,
    justherbs,
    es,
  },
  secure: {
    verified,
    secure,
    reserve,
  },
  app: {
    earn,
    reward,
    ixigo,
  },
  online: {
    onlinestep1,
    onlinestep2,
    onlinestep3,
    ticket,
  },
  offline: {
    offlinestep1,
    offlinestep2,
    offlinestep3,
    weekendofflinestep2,
  },
  userInfo: {
    usercount,
    rewardSaved,
    rated,
  },
  gateway_categories: {
    bus,
    train,
    flight,
  },
  verified: {},
  seasonOfSavingsCategories: {
    ss_food,
    ss_travel,
    ss_shopping,
    ss_electronics,
    ss_entertainment,
  },
  seasonOfSavingsSpotlightBrands: {
    ss_TheManCompany,
    ss_Nobero,
    ss_Neemans,
    ss_Boat,
    ss_Eatsure,
    ss_IxigoHotels,
    ss_Redbus,
    ss_EasemyTrip,
  },
  seasonOfSavingsOtherBrands: {
    ssob_ConfirmTkt,
    ssob_BookMyShow,
    ssob_Neemans,
    ssob_Zeeraki,
    ssob_Netmeds,
  },
  seasonOfSavingsAppExclusive: {
    ssae_TwidStars,
    ssae_TwidScanAndPay,
    ssae_Ixigo,
  },
  republicDayDealsCategories: {
    ss_food,
    ss_travel,
    ss_shopping,
    rdd_electronics,
    ss_entertainment,
  },
  republicDayDealsBrandsInSpotlight: {
    rdd_Swiggy,
    rdd_JioMart,
    rdd_Instamart,
    rdd_AbhiBus,
    rdd_Eatsure,
    rdd_Redbus,
    rdd_Nobero,
    rdd_EasemyTrip,
    rdd_TheManCompany,
  },
  republicDayDealsOtherBrands: {
    rdd_ob_ConfirmTkt,
    rdd_ob_BookMyShow,
    rdd_ob_Zeeraki,
    rdd_ob_Netmeds,
    rdd_ob_JustHerbs,
  },
  republicDayDealsAppExclusive: {
    ssae_TwidStars,
    ssae_TwidScanAndPay,
    ssae_Ixigo,
  },
};
